import { config } from "@src/navigators/Linking";
import _ from "lodash";
import moment from "moment";

const descendingComparator = (a: any, b: any, orderBy: string) => {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
};

export const getComparator = (order: any, orderBy: string) => {
  return order === "descending"
    ? (a: any, b: any) => descendingComparator(a, b, orderBy)
    : (a: any, b: any) => -descendingComparator(a, b, orderBy);
};

export const applySortFilter = (array: any, comparator: any) => {
  const stabilizedThis = array.map((el: any, index: number) => [el, index]);
  stabilizedThis.sort((a: any, b: any) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });

  return stabilizedThis.map((el: any) => el[0]);
};

export const getSilverGold = (array: any = []) => {
  const coinTypes = ["SILVER", "GOLD", "GOLD BONUS"];
  const balanceByCoinType: any = {};

  // Initialize balance for each coin type to 0
  coinTypes.forEach((coinType) => {
    balanceByCoinType[coinType] = 0;
  });

  // Calculate the balance for each coin type
  array.forEach((item: any) => {
    const coinTypeName = item.coinType.name;
    if (coinTypes.includes(coinTypeName)) {
      balanceByCoinType[coinTypeName] += item.amount;
    }
  });

  return balanceByCoinType;
};

export const checkMissionsKeys = (newState: any, type: any) => {
  newState = newState.reduce((result: any, value: any) => {
    const name = value?.mission?.name ?? "";

    if (type === "clearkey" && value.hasKey) {
      result.push({
        ...value,
        hasKey: null,
      });

      return result;
    }

    if (value.status === "ACTIVE" && name.toLowerCase().includes(type)) {
      result.push({
        ...value,
        status: "COMPLETED",
        completedDate: moment().format(),
        hasKey: true,
      });
    } else {
      result.push(value);
    }

    return result;
  }, []);

  return newState;
};

export const updateMissions = (currentState: any, newState: any) => {
  currentState = currentState.map((item: any) => {
    if(item.id === newState.id){
      return newState;
    }
    return item;
  });
  return currentState;
};

export const readNotification = (newState: any[], notifcationDetals: any) => {
  const itemIndex = _.find(newState, { id: notifcationDetals.id });

  if (itemIndex.status === "READ") {
    return newState;
  }

  return _.map(newState, (item: any) => {
    if (item.id === notifcationDetals.id && item.status !== "READ") {
      return { ...item, ...notifcationDetals };
    } else {
      return item;
    }
  });
};

export const deleteNotification = (newState: any[], notifcationDetals: any) => {
  const index = _.findIndex(newState, { id: notifcationDetals.id });

  if(index !== -1){
    newState.splice(index, 1);
  }

  return newState;
};

export const userRewardsUpdate = (userRewards: any[], userRewardsId: any) => {
  return userRewards.map((item: any) => {
    if (item.id === userRewardsId) {
      return { ...item, status: "CLAIMED" };
    } else {
      return item;
    }
  });
};

export const schedulePopup = () => {
  const day = moment().day();

  switch(day){
  case 1:
    return "WeeklyBooster";
  case 2:
    return "HotDeals";
  case 3:
    return "HighRoller";
  case 5:
    return "TGIF";
  default: 
    return "StarterPack";
  }
};

// CALCULATE TIME BASE ON END DATE
export const calculateTimeLeft = (endDate: string) => {
  const now = moment();
  const end = moment(endDate);
  const difference = end.diff(now);
  const duration = moment.duration(difference);
  
  return {
    days: duration.days(),
    hours: duration.hours(),
    minutes: duration.minutes()
  };
};

// FIND SCREEN KEY FROM LINKING SCREENS
export const findScreenKey = (value: string): string | undefined => {
  const screens = config.screens;
  // Iterate through the keys and values of the screens object
  for (const [key, val] of Object.entries(screens)) {
    if (val === value) {
      return key; // Return the key if the value matches
    }
  }
  return undefined; // Return undefined if no match is found
};

// FIND SCREEN KEY FROM LINKING SCREENS
export const findGameByCode = (games: any[], code: string): any => {
  for (const game of games) {
    if (game.code === code) {
      return game; // Return top-level game
    }
    if (game.child) {
      const foundChild = game.child.find((child: any) => child.code === code);
      if (foundChild) {
        return foundChild; // Return child game
      }
    }
  }
  return {}; // Return null if no game is found
};

// FIND GAMES BASE ON ID
export const findGameByID = (games: any[], id: number): any => {
  for (const game of games) {
    if (game.id === id) {
      return game; // Return top-level game
    }
    if (game.child) {
      const foundChild = game.child.find((child: any) => child.id === id);
      if (foundChild) {
        return foundChild; // Return child game
      }
    }
  }
  return {}; // Return null if no game is found
};

// CHECK HOW TO PLAY AND FAVOURITE STATUS
export const checkDismissalStatus = (ctaMessages: any[]) => { 
  const dismissValue: any = {};

  ctaMessages.forEach((item: any) => {
    dismissValue[item.type] = item.isDismissed;
  });

  return dismissValue;
};
